import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { admin, apiErr } from "../../lib/api";
import { inr } from "../../lib/format";
import { panel, inputCls, btnPrimary, btnGhost, PageHead } from "../ui";

const NEXT = {
  Pending: ["Confirmed", "Cancelled"], Confirmed: ["Processing", "Cancelled"],
  Processing: ["Shipped", "Cancelled"], Shipped: ["Delivered", "Cancelled"],
  Delivered: ["Refunded"], Cancelled: [], Refunded: [],
};

export default function OrderDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [o, setO] = useState(null);
  const [notes, setNotes] = useState("");

  const load = () => admin.get(`/admin/orders/${id}`).then((r) => { setO(r.data); setNotes(r.data.internal_notes || ""); });
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [id]);

  if (!o) return <p className="text-zinc-500">Loading…</p>;

  const transition = async (status) => {
    try { await admin.put(`/admin/orders/${id}/status`, { status }); toast.success(`Order ${status}`); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const saveNotes = async () => { await admin.put(`/admin/orders/${id}/notes`, { internal_notes: notes }); toast.success("Notes saved"); };

  return (
    <div>
      <PageHead title={o.order_number}>
        <button onClick={() => navigate("/admin/orders")} className={btnGhost}>Back</button>
      </PageHead>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        <div className={`${panel} p-5 lg:col-span-2`}>
          <h2 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Items</h2>
          {o.items.map((it, i) => (
            <div key={i} className="flex items-center gap-3 py-2 border-b border-zinc-900">
              <img src={it.image} alt="" className="w-12 h-14 object-cover bg-zinc-900" />
              <div className="flex-1"><p className="text-sm text-zinc-100">{it.name}</p><p className="text-xs text-zinc-500">{[it.size, it.color].filter(Boolean).join(" / ")} × {it.qty}</p></div>
              <span className="text-sm text-white">{inr(it.line_total)}</span>
            </div>
          ))}
          <div className="mt-4 space-y-1 text-sm">
            <div className="flex justify-between text-zinc-400"><span>Subtotal</span><span>{inr(o.subtotal)}</span></div>
            {o.discount > 0 && <div className="flex justify-between text-accent"><span>Discount {o.coupon_code ? `(${o.coupon_code})` : ""}</span><span>-{inr(o.discount)}</span></div>}
            <div className="flex justify-between text-zinc-400"><span>Shipping</span><span>{o.shipping ? inr(o.shipping) : "FREE"}</span></div>
            <div className="flex justify-between text-white font-bold pt-2 border-t border-zinc-800"><span>Total</span><span>{inr(o.total)}</span></div>
          </div>
        </div>

        <div className="space-y-5">
          <div className={`${panel} p-5`}>
            <h2 className="text-sm font-semibold text-white uppercase tracking-wider mb-3">Status: <span className="text-accent">{o.status}</span></h2>
            <div className="flex flex-wrap gap-2">
              {(NEXT[o.status] || []).map((s) => (
                <button key={s} onClick={() => transition(s)} className={s === "Cancelled" ? btnGhost : btnPrimary} data-testid={`status-to-${s}`}>{s}</button>
              ))}
              {(NEXT[o.status] || []).length === 0 && <p className="text-xs text-zinc-500">No further transitions.</p>}
            </div>
            <p className="text-xs text-zinc-500 mt-3">Payment: {o.payment_method?.toUpperCase()} — {o.payment_status}</p>
          </div>

          <div className={`${panel} p-5 text-sm`}>
            <h2 className="text-sm font-semibold text-white uppercase tracking-wider mb-3">Shipping</h2>
            <p className="text-zinc-300">{o.shipping_address?.name}</p>
            <p className="text-zinc-500">{o.shipping_address?.line1}, {o.shipping_address?.line2}</p>
            <p className="text-zinc-500">{o.shipping_address?.city}, {o.shipping_address?.state} — {o.shipping_address?.pincode}</p>
            <p className="text-zinc-500 mt-2">{o.contact?.email} · {o.contact?.phone}</p>
          </div>

          <div className={`${panel} p-5`}>
            <h2 className="text-sm font-semibold text-white uppercase tracking-wider mb-3">Internal Notes</h2>
            <textarea rows={3} className={inputCls} value={notes} onChange={(e) => setNotes(e.target.value)} />
            <button onClick={saveNotes} className={btnGhost + " mt-2"}>Save Notes</button>
          </div>
        </div>
      </div>
    </div>
  );
}
